import Api from '../Api';
import { errorNotification } from '../Snackbar';

export const setJobchartFiles =
  (productIndex, file, isRemove) => async dispatch =>
    dispatch({
      type: 'SET_JOBCHART_FILES',
      payload: { productIndex, file, isRemove: Boolean(isRemove) },
    });

export const deleteJobchartProduct = productIndex => async dispatch =>
  dispatch({
    type: 'DELETE_PRODUCT_JOBCHART',
    payload: { productIndex },
  });

export const clearJobchartFiles = () => {
  return {
    type: 'CLEAR_JOBCHART_FILES',
  };
};

export const getJobcharts = query => async dispatch => {
  const { data } = await Api.get(`/jobcharts`, query);
  dispatch({
    type: 'FETCH_JOBCHARTS',
    payload: data,
  });
};

export const clearJobcharts = () => {
  return {
    type: 'CLEAR_JOBCHARTS',
  };
};

export const getJobchart = id => async dispatch => {
  const { data } = await Api.get(`/jobcharts/${id}`);
  dispatch({
    type: 'FETCH_JOBCHART',
    payload: data,
  });
};

export const clearJobchart = () => {
  return {
    type: 'CLEAR_JOBCHART',
  };
};

export const getJobchartPreview = id => async dispatch => {
  try {
    const { data } = await Api.get(`/jobcharts/preview/${id}`);
    dispatch({
      type: 'FETCH_JOBCHART_PREVIEW',
      payload: data,
    });
  } catch (error) {
    errorNotification(error);
  }
};

export const clearJobchartPreview = () => {
  return {
    type: 'CLEAR_JOBCHART_PREVIEW',
  };
};

export const getActiveJobchartIds = params => async dispatch => {
  try {
    const { data } = await Api.get(`/jobcharts/active`, params);
    dispatch({
      type: 'FETCH_ACTIVE_JOBCHART_IDS',
      payload: data,
    });
  } catch (error) {
    errorNotification(error);
  }
};

export const clearActiveJobchartIds = () => {
  return {
    type: 'CLEAR_ACTIVE_JOBCHART_IDS',
  };
};

export const getSavedJobcharts = () => async dispatch => {
  try {
    const { data } = await Api.get(`/jobcharts/savedlist`);
    dispatch({
      type: 'FETCH_SAVED_JOBCHARTS',
      payload: data,
    });
  } catch (error) {
    errorNotification(error);
  }
};

export const clearSavedJobcharts = () => {
  return {
    type: 'CLEAR_SAVED_JOBCHARTS',
  };
};

export const getJobchartAcknowledgements = id => async dispatch => {
  try {
    const { data } = await Api.get(`/jobcharts/acknowledgements/${id}`);

    dispatch({
      type: 'FETCH_JOBCHART_ACKNOWLEDGEMENTS',
      payload: data,
    });
  } catch (error) {
    errorNotification(error);
  }
};

export const clearJobchartAcknowledgements = () => {
  return {
    type: 'CLEAR_JOBCHART_ACKNOWLEDGEMENTS',
  };
};
